module.exports = __webpack_public_path__ + "static/media/03-1-galeria-04-burberry-mobile@2x.23c9ce33.jpg";